<div class="menu-list" [disableRipple]="true" *ngIf="menus" (mouseleave)="exitAllSections()">
    <div *ngFor="let section of menus; let i = index">
        <ng-container>
            <div
                id="{{ section.page.module }}-button"
                class="menu-list-item {{ section.page.module }}-button"
                [ngClass]="getActiveClass(section.page.module, section.page.routerURL)"
            >
                <div
                    (mouseenter)="onSectionSelected(section)"
                    (click)="accordianMenuOpenClose(section); navigateTo(section)"
                    class="menu-list-item-info-container"
                >
                    <div class="menu-list-item-info-area">
                        <span class="menu-list-item-info-data">
                            <button mat-icon-button class="menu-list-icon-button">
                                <mat-icon
                                    fontSet="fas"
                                    fontIcon="{{ section.page.icon }}"
                                ></mat-icon>
                            </button>
                            <label class="page-name-label">{{ section.page.name }}</label>
                        </span>
                    </div>
                    <div class="menu-toggle-button">
                        <span *ngIf="isMobile && section.subPages.length > 0">
                            <i class="fas fa-angle-down" *ngIf="!section.page.expanded"></i>
                            <i class="fas fa-angle-up" *ngIf="section.page.expanded"></i>
                        </span>
                    </div>
                    <ng-container *ngTemplateOutlet="flyOutMenu; context: { $implicit: section }">
                    </ng-container>
                </div>
            </div>
            <div *ngIf="section.page.hasDivider === true">
                <span class="incentives-divider"></span>
            </div>
        </ng-container>

        <!-- accordian sub-menu -->
        <div *ngIf="section.page.expanded && isMobile" class="accordianWrapper">
            <!-- head-section -->
            <div
                class="accordian-section"
                routerLinkActive="accordian-active"
                [routerLinkActiveOptions]="{ exact: true }"
                *ngIf="section.subPages.length > 0"
            >
                <div
                    routerLink="{{ section.page.routerURL }}"
                    class="accordianSubSectionHeading"
                    (click)="mobileMenuClicked(section)"
                >
                    <span>{{ section.page.name }} Home</span>
                </div>
            </div>
            <!-- sub-sections -->
            <div *ngIf="section.subPages.length > 0">
                <div
                    *ngFor="let sub of section.subPages"
                    class="accordian-section"
                    routerLinkActive="flyout-active"
                >
                    <ng-container *ngIf="!sub.isLocked">
                        <div
                            class="accordianSubSectionDetail"
                            routerLink="{{ sub.routerURL }}"
                            style="text-decoration: none"
                            (click)="mobileMenuClicked(section)"
                        >
                            <span>{{ sub.name }}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="sub.isLocked">
                        <div class="accordianSubSectionDetail" style="text-decoration: none">
                            <span>{{ sub.name }}</span>
                            <span>
                                <mat-icon
                                    fontSet="fas"
                                    fontIcon="fa-lock"
                                    class="submenu-icon-inner"
                                ></mat-icon>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- fly-out sub-menu -->
<ng-template #flyOutMenu let-section>
    <div
        *ngIf="section && section.page.expanded && !isMobile"
        class="popOutWrapper"
        [style.transform]="'translate(' + navWidth + 'px, 2%)'"
        (keydown)="onKeydownHandler($event)"
        (mouseenter)="mouseEnter(section)"
        (mouseleave)="mouseLeave(section)"
    >
        <!--head-section-->
        <div
            class="flyout-section flyout-line"
            routerLinkActive="flyout-active"
            [routerLinkActiveOptions]="{ exact: true }"
        >
            <div
                class="subSectionHeading"
                style="text-decoration: none"
                routerLink="{{ section.page.routerURL }}"
                (click)="closeFlyout(section)"
            >
                <span
                    >{{ section.page.name }}
                    <span *ngIf="section.subPages.length > 0"> Home</span></span
                >
            </div>
        </div>
        <!--sub-sections-->
        <div [ngClass]="section.subPages.length > 0 ? 'sub-padding-bottom ' : ''">
            <div
                *ngFor="let sub of section.subPages"
                class="flyout-section"
                routerLinkActive="flyout-active"
            >
                <ng-container *ngIf="!sub.isLocked">
                    <div
                        class="subSectionDetail"
                        routerLink="{{ sub.routerURL }}"
                        (click)="closeFlyout(section)"
                    >
                        <span>{{ sub.name }}</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="sub.isLocked">
                    <div class="subSectionDetail">
                        <span>{{ sub.name }}</span>
                        <span>
                            <mat-icon
                                fontSet="fas"
                                fontIcon="fa-lock"
                                class="submenu-icon-inner"
                            ></mat-icon>
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>
